// @core/api/endpoints/license/sync_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SyncLicenseRequest,
  SyncLicenseResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Force license sync
 * Forces the local license service to synchronize with the master. Fetches the latest license state, entitlements, and signing keys.
 */
export async function SyncLicense(
  data: SyncLicenseRequest,
  options?: RequestOptions
): Promise<SyncLicenseResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses/sync`;
  const requestOptions = options;
  return client.post<SyncLicenseResponse>(requestPath, data, requestOptions);
}
